//Wrapper for logger for safer usage
const logger = process.server ? require('../utils/logger') : null;

const logInfo = msg => {
  if (process.server && logger && process.env.NODE_ENV === 'production') logger.info(msg);
  else console.log(msg);
};

const logError = err => {
  if (process.server && logger && process.env.NODE_ENV === 'production') logger.error(err);
  else console.error(err);
};

export const logWrapper = {
  logInfo,
  logError
};
